// Formatacao para exibicao. O servidor manda UTC e numeros crus; formatar e
// responsabilidade do cliente (convencao do CLAUDE.md).

import type { ContestStatus, Verdict } from "@compila/shared";

/** Segundos em HH:MM:SS — o cronometro da prova. */
export function formatClock(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return [h, m, sec].map((n) => String(n).padStart(2, "0")).join(":");
}

/** Segundos de prova como "MM:SS" ou "H:MM:SS", para a coluna de hora. */
export function formatContestTime(seconds: number): string {
  return formatClock(seconds);
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function formatTime(ms: number | null): string {
  if (ms === null) return "—";
  return ms < 1000 ? `${ms} ms` : `${(ms / 1000).toFixed(2)} s`;
}

export function formatMemory(kb: number | null): string {
  if (kb === null) return "—";
  return kb < 1024 ? `${kb} KB` : `${(kb / 1024).toFixed(1)} MB`;
}

export const VERDICT_LABEL: Record<Verdict, string> = {
  AC: "Aceito",
  WA: "Resposta errada",
  TLE: "Tempo excedido",
  MLE: "Memoria excedida",
  RE: "Erro de execucao",
  CE: "Erro de compilacao",
};

export const CONTEST_STATUS_LABEL: Record<ContestStatus, string> = {
  DRAFT: "Nao iniciado",
  RUNNING: "Em andamento",
  PAUSED: "Pausado",
  ENDED: "Encerrado",
};

/** Classes do Tailwind por veredito. Verde so para AC; CE em cinza, porque nao penaliza. */
export function verdictClasses(verdict: Verdict): string {
  switch (verdict) {
    case "AC":
      return "bg-emerald-100 text-emerald-800 ring-emerald-600/30";
    case "CE":
      return "bg-slate-100 text-slate-700 ring-slate-500/30";
    case "TLE":
    case "MLE":
      return "bg-amber-100 text-amber-800 ring-amber-600/30";
    default:
      return "bg-rose-100 text-rose-800 ring-rose-600/30";
  }
}
